import AddAttributeModal from './modals/AddAttributeModal';
import AddTermModal from './modals/AddTermModal';
import EditTermModal from './modals/EditTermModal';
import EditAttributeModal from './modals/EditAttributeModal';

export default function Modals(props) {
  return (
    <>
      <AddAttributeModal
        showModal={props.showModal}
        closeModal={props.closeModal}
        triggerRefresh={props.triggerRefresh}
      />

      <AddTermModal
        showTermModal={props.showTermModal}
        closeTermModal={props.closeTermModal}
        taxonomy={props.termModalContext && props.termModalContext.taxonomy}
        type={props.termModalContext && props.termModalContext.type}
        triggerRefresh={props.triggerRefresh}
        openMediaLibrary={props.openMediaLibrary}
      />

      <EditTermModal
        showEditModal={props.showEditModal}
        closeEditModal={props.closeEditModal}
        term={props.editTargetTerm}
        triggerRefresh={props.triggerRefresh}
        openMediaLibrary={props.openMediaLibrary}
      />

      <EditAttributeModal
        showEditAttributeModal={props.showEditAttributeModal}
        closeEditAttributeModal={props.closeEditAttributeModal}
        attribute={props.attributeTarget}
        triggerRefresh={props.triggerRefresh}
      />
    </>
  );
}
